import {
  AutocompleteInput,
  AutocompleteInputProps,
  OpenInNewInputAdorement,
} from '@kirz/mui-admin';
import React from 'react';

export function clientSearchOrConditions(search: string) {
  return [
    ...(Number.isInteger(parseInt(search, 10)) && search.length < 7
      ? [{ id: { _eq: parseInt(search, 10) } }]
      : []),
    { fullName: { _ilike: `%${search}%` } },
  ];
}

export function clientSearchFilter(search: string) {
  return { _or: clientSearchOrConditions(search) };
}

type HasuraAutocompleteInputProps = Extract<
  AutocompleteInputProps,
  { mode: 'hasura' }
>;

type ClientAutocompleteInputProps = Omit<
  HasuraAutocompleteInputProps,
  'mode' | 'source' | 'name' | 'label' | 'selection' | 'itemText' | 'fetchAll'
> & {
  showOpenInNew?: boolean;
  name?: string;
  label?: string;
};

export function ClientAutocompleteInput({
  showOpenInNew = true,
  name = 'clientId',
  label = 'Клиент',
  filter: customFilter,
  ...props
}: ClientAutocompleteInputProps) {

  return (
    <AutocompleteInput
      {...props}
      name={name}
      mode="hasura"
      source="client"
      label={label}
      selection="id fullName"
      itemText={(x) => `#${x.id} ${x.fullName}`}
      fetchAll={false}
      filter={customFilter ?? clientSearchFilter}
      inputProps={{
        ...props.inputProps,
        ...(showOpenInNew && {
          InputProps: {
            ...props.inputProps?.InputProps,
            startAdornment: (
              <OpenInNewInputAdorement field={name} baseUrl="/clients" />
            ),
          },
        }),
      }}
    />
  );
}
